import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Link, useNavigate, useParams } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import $ from 'jquery';
import 'datatables.net-bs5';
import config from "./common/Config";
import Swal from 'sweetalert2';
import { setTableWidths, getTableWidths, setTableColumnVisibility, getTableColumnVisibility } from "../data/postAPi";
import generateMultipleSummaryPDF from "./trip/generateMultipleSummaryPDF_dds";
import ManageColumns from "./tableComponents/manageColumns/ManageColumns";
import FallbackManageColumns from "./tableComponents/manageColumns/FallbackManageColumns";
import StandaloneManageColumnsModal from "./tableComponents/manageColumns/StandaloneManageColumnsModal";

const NewMarkDelivery = () => {
	const { manifestId } = useParams();
	const [options, setOptions] = useState([]);
	const [driver, setSelectedDriver] = useState('');
	const [manifestOrder, setmanifestOrder] = useState('');
	const [orderOptions, setorderOptions] = useState([]);
	const [isManifest, setIsManifest] = useState(false);
	const [showDriverModal, setShowDriverModal] = useState(false);
	const [selectedDriverName, setSelectedDriverName] = useState('');
	const [companySettings, setCompanySettings] = useState(null);
	const [howManyInvoiceCanPrint, setHowManyInvoiceCanPrint] = useState(1);

	const [isAllSelected, setIsAllSelected] = useState(false);
	const [selectedRows, setSelectedRows] = useState([]);
	const [tableData, setTableData] = useState([]);
	const [printProcessed, setPrintProcessed] = useState(false);

	const tableRef = useRef(null);
	const dataTableRef = useRef(null);
	const accessToken = localStorage.getItem("accessToken");
	const navigate = useNavigate();
	const userId = localStorage.getItem("userId");
	const tableName = "newmarkdownTable";

	const defaultWidths = [80, 80, 120, 200, 150, 120, 120, 120, 120, 100];
	const [colWidths, setColWidths] = useState(defaultWidths);

	const tableColumns = [
		{ header: "Checkbox", visible: true },
		{ header: "Seq. No", visible: true },
		{ header: "Distance", visible: true },
		{ header: "Inv Date", visible: true },
		{ header: "Inv Number", visible: true },
		{ header: "Customer Name(A/c No)", visible: true },
		{ header: "Post Code", visible: true },
		{ header: "Inv Amt", visible: true },
		{ header: "Amt Dues", visible: true },
		{ header: "Action", visible: true }
	];

	const [columnVisibility, setColumnVisibility] = useState(() => {
		const defaultVisibility = {};
		tableColumns.forEach((_, index) => {
			defaultVisibility[index] = true;
		});
		return defaultVisibility;
	});

	const [showFallbackModal, setShowFallbackModal] = useState(false);

	const handleColumnVisibilityChange = async (newVisibility) => {
		console.log('Updating column visibility:', newVisibility);
		setColumnVisibility(newVisibility);

		try {
			await setTableColumnVisibility(userId, tableName, newVisibility);
		} catch (error) {
			console.error('Error saving column visibility:', error);
		}

		if ($.fn.DataTable.isDataTable('#newmarkdownTable')) {
			const table = $('#newmarkdownTable').DataTable();

			tableColumns.forEach((column, index) => {
				const isVisible = newVisibility[index] !== false;
				table.column(index).visible(isVisible);
			});

			table.draw();
		}
	};

	function debounce(func, wait) {
		let timeout;
		return function (...args) {
			clearTimeout(timeout);
			timeout = setTimeout(() => func.apply(this, args), wait);
		};
	}

	const debouncedSetTableWidths = useRef(
		debounce((userId, tableName, widths) => {
			setTableWidths(userId, tableName, widths);
		}, 500)
	).current;

	const startResizing = (index, e) => {
		e.preventDefault();
		const startX = e.clientX;
		const startWidth = colWidths[index];

		const onMouseMove = (moveEvent) => {
			const newWidth = Math.max(50, startWidth + moveEvent.clientX - startX);
			setColWidths((widths) => {
				const updated = [...widths];
				updated[index] = newWidth;
				debouncedSetTableWidths(userId, tableName, updated);
				return updated;
			});
		};

		const onMouseUp = () => {
			document.removeEventListener("mousemove", onMouseMove);
			document.removeEventListener("mouseup", onMouseUp);
		};

		document.addEventListener("mousemove", onMouseMove);
		document.addEventListener("mouseup", onMouseUp);
	};

	const checkPopupBlocker = () => {
		let testWindow;
		try {
			testWindow = window.open('', '_blank', 'width=1,height=1,top=0,left=0');
			
			if (!testWindow) {
				showPopupBlockedMessage();
				return false;
			}

			setTimeout(() => {
				try {
					if (testWindow.closed || !testWindow.location || testWindow.location.href === 'about:blank') {
						if (!testWindow.closed) {
							testWindow.close();
						}
					} else {
						testWindow.close();
					}
				} catch (e) {
					if (!testWindow.closed) {
						testWindow.close();
					}
				}
			}, 100);

			if (testWindow.outerHeight === 0 || testWindow.outerWidth === 0) {
				showPopupBlockedMessage();
				return false;
			}

			if (testWindow.screenX === 0 && testWindow.screenY === 0) {
				showPopupBlockedMessage();
				return false;
			}

			return true;
		} catch (e) {
			showPopupBlockedMessage();
			return false;
		}
	};

	const showPopupBlockedMessage = () => {
		Swal.fire({
			title: 'Popup Blocked',
			html: `
				<div style="text-align: left;">
					<p>Popups are blocked for this site. To enable printing:</p>
					<ul style="margin: 10px 0;">
						<li>Look for a popup blocker icon in your address bar</li>
						<li>Click on it and select "Always allow popups from this site"</li>
						<li>Or go to browser Settings > Privacy > Pop-ups and redirects</li>
						<li>Add this site to the allowed list</li>
					</ul>
					<p>Then try printing again.</p>
				</div>
			`,
			icon: 'warning',
			confirmButtonText: 'OK',
			width: '500px'
		});
	};

	const clearPrintUrlParam = () => {
		const url = new URL(window.location);
		url.searchParams.delete('print');
		window.history.replaceState({}, document.title, url.pathname + url.search);
	};

	useEffect(() => {
		async function fetchWidths() {
			try {
				const res = await getTableWidths(userId, tableName);
				if (res?.data?.widths && Array.isArray(res.data.widths) && res.data.widths.length > 0) {
					const apiWidths = res.data.widths;
					let adjustedWidths = [...defaultWidths];

					if (apiWidths.length === 9 && defaultWidths.length === 10) {
						adjustedWidths = [defaultWidths[0], ...apiWidths];
					} else if (apiWidths.length === defaultWidths.length) {
						adjustedWidths = apiWidths;
					}

					setColWidths(adjustedWidths);
				} else {
					setColWidths(defaultWidths);
				}
			} catch (e) {
				console.error('Error fetching widths:', e);
				setColWidths(defaultWidths);
			}
		}
		fetchWidths();
	}, [userId, tableName]);

	useEffect(() => {
		async function fetchColumnVisibility() {
			try {
				const visibilityResponse = await getTableColumnVisibility(userId, tableName);
				if (visibilityResponse?.data?.column_visibility) {
					console.log('Loaded column visibility from API:', visibilityResponse.data.column_visibility);
					setColumnVisibility(visibilityResponse.data.column_visibility);
				} else {
					const defaultVisibility = {};
					tableColumns.forEach((_, index) => {
						defaultVisibility[index] = true;
					});
					setColumnVisibility(defaultVisibility);
				}
			} catch (error) {
				console.error('Error loading column visibility from API:', error);
				const defaultVisibility = {};
				tableColumns.forEach((_, index) => {
					defaultVisibility[index] = true;
				});
				setColumnVisibility(defaultVisibility);
			}
		}
		fetchColumnVisibility();
	}, [userId, tableName]);

	useEffect(() => {
		if ($.fn.DataTable.isDataTable('#newmarkdownTable')) {
			const table = $('#newmarkdownTable').DataTable();

			tableColumns.forEach((column, index) => {
				const isVisible = columnVisibility[index] !== false;
				table.column(index).visible(isVisible);
			});

			table.draw();
		}
	}, [columnVisibility]);

	useEffect(() => {
		async function fetchDriverOptions() {
			try {
				const response = await axios.post(
					`${config.API_URL}/getDriver`,
					{},
					{
						headers: {
							authorization: `Bearer ${accessToken}`,
						},
					}
				);

				if (!response.data || !response.data.data.driver || !Array.isArray(response.data.data.driver)) {
					throw new Error('Invalid response format or empty driver array');
				}

				const formattedOptions = response.data.data.driver.map(item => ({
					key: `${item.first_name} ${item.last_name}`,
					value: item.id,
				}));

				setOptions(formattedOptions);
			} catch (error) {
				console.error('Error fetching driver options:', error);
			}
		}

		fetchDriverOptions();
	}, [accessToken]);

	useEffect(() => {
		async function fetchOrderOptions() {
			try {
				const response = await axios.get(`${config.API_URL}/manifest_orderlist`, {
					headers: {
						authorization: `Bearer ${accessToken}`,
					},
				});
				if (!response.data || !response.data.data.orders || !Array.isArray(response.data.data.orders)) {
					throw new Error('Invalid response format or empty order array');
				}
				const manifest_orderOptions = response.data.data.orders.map(item => ({
					key: `${item.reference_no}`,
					value: item.id,
				}));

				setorderOptions(manifest_orderOptions);
			} catch (error) {
				console.error('Error fetching orders options:', error);
			}
		}
		fetchOrderOptions();
	}, [accessToken]);

	useEffect(() => {
		async function fetchCompanySettings() {
			try {
				const response = await fetch(`${config.API_URL}/settings/ws-get-company-settings`, {
					method: 'POST',
					headers: {
						authorization: `Bearer ${accessToken}`,
					},
				});
				const data = await response.json();
				setCompanySettings(data?.data);
				if (data?.data?.howmanyInvoiceCanPrint) {
					setHowManyInvoiceCanPrint(Number(data.data.howmanyInvoiceCanPrint));
				}
			} catch (error) {
				console.error('Error fetching company settings:', error);
			}
		}
		fetchCompanySettings();
	}, [accessToken]);

	const fetchData = async () => {
		const formData = new FormData();
		formData.append('id_new', manifestId);
		formData.append('draw', 1);
		formData.append('start', 0);
		formData.append('length', 50);

		const apiUrl = `${config.API_URL}/manifest_list/get_mark_delivery`;
		try {
			const response = await fetch(apiUrl, {
				method: 'POST',
				headers: {
					authorization: `Bearer ${accessToken}`,
				},
				body: formData,
			});
			if (!response.ok) {
				throw new Error('Failed to fetch new sales data');
			}

			const data = await response.json();
			setIsManifest(data.is_manifest === 'Y');
			setSelectedDriver(data.driver_id);

			if (data.driver_id) {
				const selectedDriverOption = options.find(option => option.value === data.driver_id);
				if (selectedDriverOption) {
					setSelectedDriverName(selectedDriverOption.key);
				}
			}
		} catch (error) {
			console.error('Error fetching new sales data:', error);
		}
	};

	useEffect(() => {
		fetchData();
	}, [manifestId, accessToken, options]);

	useEffect(() => {
		const urlParams = new URLSearchParams(window.location.search);
		const printParam = urlParams.get('print');
		
		if (printParam === 'true' && !printProcessed && tableData.length > 0) {
			setPrintProcessed(true);
			
			const allIds = tableData.map(row => row.id);
			setSelectedRows(allIds);
			setIsAllSelected(true);
			$('.order-checkbox').prop('checked', true);

			setTimeout(() => {
				try {
					handleMultiplePrintWithIds(allIds);
					clearPrintUrlParam();
				} catch (error) {
					showPopupBlockedMessage();
					clearPrintUrlParam();
				}
			}, 500);
		}
	}, [tableData, printProcessed]);

	const destroyDataTable = () => {
		if (dataTableRef.current) {
			try {
				$(document).off('blur', '.sequence-input');
				$(document).off('click', '.delete-order-btn');
				$(document).off('change', '.order-checkbox');

				dataTableRef.current.destroy();
				dataTableRef.current = null;
			} catch (error) {
				console.warn('Error destroying DataTable:', error);
				dataTableRef.current = null;
			}
		}
	};

	const addResizerToSeqNo = () => {
		const th = document.querySelector('#newmarkdownTable thead th[data-dt-column="1"]');
		if (th && !th.querySelector('.th-resizer')) {
			const resizer = document.createElement('div');
			resizer.className = 'th-resizer';
			resizer.style.position = 'absolute';
			resizer.style.right = '-2px';
			resizer.style.top = '0';
			resizer.style.width = '5px';
			resizer.style.height = '100%';
			resizer.style.cursor = 'col-resize';
			resizer.style.zIndex = '999';
			resizer.style.userSelect = 'none';
			resizer.onmousedown = (e) => startResizing(1, e);
			th.style.position = 'relative';
			th.appendChild(resizer);
		}
	};

	const updateSelectedRows = () => {
		const checkedBoxes = $('.order-checkbox:checked');
		const newSelectedRows = [];
		checkedBoxes.each(function () {
			const id = $(this).data('id');
			if (id) {
				newSelectedRows.push(id);
			}
		});
		setSelectedRows(newSelectedRows);
		setIsAllSelected(checkedBoxes.length > 0 && checkedBoxes.length === $('.order-checkbox').length);
	};

	useEffect(() => {
		destroyDataTable();

		const timeoutId = setTimeout(() => {
			const $table = $(tableRef.current);

			if (!$table.length) {
				console.error('Table element not found');
				return;
			}

			try {
				const table = $table.DataTable({
					processing: true,
					serverSide: true,
					destroy: true,
					searching: false,
					pageLength: 50,
					ordering: false,
					ajax: {
						url: `${config.API_URL}/manifest_list/get_mark_delivery`,
						type: 'POST',
						headers: {
							authorization: `Bearer ${accessToken}`,
						},
						data: function (d) {
							return $.extend({}, d, {
								id_new: manifestId,
								authorization: `Bearer ${accessToken}`,
							});
						},
						dataSrc: function (json) {
							console.log("API Response:", json);

							if (json && json.data) {
								json.recordsTotal = json.data.length;
								json.recordsFiltered = json.data.length;

								setIsManifest(json.is_manifest === 'Y');
								setSelectedDriver(json.driver_id);
								setTableData(json.data);

								return json.data;
							}

							console.error("Invalid data format:", json);
							return [];
						}
					},
					language: {
						paginate: {
							first: "First",
							last: "Last",
							next: "Next",
							previous: "Previous",
						},
					},
					columns: [
						{
							data: null,
							ordering: false,
							className: 'text-center',
							width: '5%',
							visible: columnVisibility[0] !== false,
							render: function (data, type, row) {
								const isChecked = selectedRows.includes(row.id);
								return `<label class="checkbox">
                  <input type="checkbox" class="order-checkbox dataTableCheckboxNew" data-id="${row.id}" ${isChecked ? 'checked' : ''} />
                  <span class="default"></span>
                </label>`;
							}
						},
						{
							data: null,
							ordering: false,
							className: 'text-center',
							width: '10%',
							title: 'Seq. No',
							visible: columnVisibility[1] !== false,
							render: function (data, type, row) {
								return `<input type="text" class="form-control sequence-input" data-id="${row.id}" value="${row.sequence_no || ''}" placeholder="Enter Seq" />`;
							}
						},
						{ data: 'mile', className: 'text-center', width: '10%', visible: columnVisibility[2] !== false },
						{ data: 'date', className: 'text-center', width: '10%', visible: columnVisibility[3] !== false },
						{
							data: null,
							className: 'text-start',
							width: '15%',
							visible: columnVisibility[4] !== false,
							render: function (data, type, row) {
								return `<a href="${config.BASE_URL}/trip_summary/print/${row.id}" target="_blank">${row.invoice_num}</a>`;
							}
						},
						{ data: 'customer', className: 'text-start', width: '20%', visible: columnVisibility[5] !== false },
						{ data: 'postal_code', className: 'text-start', width: '10%', visible: columnVisibility[6] !== false },
						{ data: 'invoice_amt', className: 'text-left', width: '10%', visible: columnVisibility[7] !== false },
						{ data: 'previous_dues', className: 'text-right', width: '10%', visible: columnVisibility[8] !== false },
						{
							data: null,
							ordering: false,
							className: 'text-center',
							width: '5%',
							visible: columnVisibility[9] !== false,
							render: function (data, type, row) {
								return `<a class="delete-order-btn" data-id="${row.id}" style="display: inline-block; text-align: center;"><i class="fa fa-trash"></i></a>`;
							}
						}
					],
					drawCallback: function (settings) {
						addResizerToSeqNo();
						setTimeout(() => {
							selectedRows.forEach(id => {
								$(`.order-checkbox[data-id="${id}"]`).prop('checked', true);
							});
							updateSelectedRows();
						}, 100);
					}
				});

				dataTableRef.current = table;
				addResizerToSeqNo();

				$(document).off('.newmarkdelivery').on('blur.newmarkdelivery', '.sequence-input', function () {
					const invoiceId = $(this).data('id');
					const sequenceNo = $(this).val();
					if (sequenceNo.trim() !== '') {
						$.ajax({
							url: `${config.API_URL}/save-sequence-no`,
							method: 'POST',
							headers: { authorization: `Bearer ${accessToken}` },
							contentType: 'application/json',
							data: JSON.stringify({ invoice_id: invoiceId, sequence_no: sequenceNo }),
							success: (response) => {
								console.log('Saved successfully:', response);
							},
							error: (xhr) => {
								console.error('Error saving sequence:', xhr.responseText);
								Swal.fire('Error', 'Failed to save sequence number.', 'error');
							}
						});
					}
				});

				$(document).on('click.newmarkdelivery', '.delete-order-btn', function () {
					const orderId = $(this).data('id');
					Swal.fire({
						title: 'Are you sure?',
						text: 'Do you want to Remove this order from here?',
						icon: 'warning',
						showCancelButton: true,
						confirmButtonText: 'Yes, Remove it!',
						cancelButtonText: 'Cancel'
					}).then((result) => {
						if (result.isConfirmed) {
							$.ajax({
								url: `${config.API_URL}/manifest_delete_order`,
								method: 'POST',
								headers: { authorization: `Bearer ${accessToken}` },
								contentType: 'application/json',
								data: JSON.stringify({ order_id: orderId, manifest_id: manifestId }),
								success: function () {
									Swal.fire('Deleted!', 'Order has been deleted.', 'success');
									setSelectedRows(prev => prev.filter(id => id !== orderId));
									if (dataTableRef.current) {
										dataTableRef.current.ajax.reload();
									}
								},
								error: function () {
									Swal.fire('Error', 'Failed to delete order.', 'error');
								}
							});
						}
					});
				});

				$(document).on('change.newmarkdelivery', '.order-checkbox', function () {
					updateSelectedRows();
				});

			} catch (error) {
				console.error('Error initializing DataTable:', error);
			}
		}, 100);

		return () => {
			clearTimeout(timeoutId);
			destroyDataTable();
		};
	}, [manifestId, accessToken]);

	const handleClick = async () => {
		let selmainval = `${manifestOrder}`;
		if (!selmainval) {
			Swal.fire({
				title: 'Error',
				text: 'Please Select order.',
				icon: 'error',
				showConfirmButton: false,
				timer: 2000,
				timerProgressBar: true,
			});
		} else {
			const formOrder = new FormData();
			formOrder.append('update_id', manifestId);
			formOrder.append('order_id', selmainval);
			try {
				const res = await fetch(`${config.API_URL}/manifest_add_order`, {
					method: 'POST',
					headers: {
						authorization: `Bearer ${accessToken}`,
					},
					body: formOrder,
				});
				if (!res.ok) {
					throw new Error('Network response was not ok');
				}
				const data = await res.json();
				fetchData();
				if (dataTableRef.current) {
					dataTableRef.current.ajax.reload();
				}
				Swal.fire({
					title: 'Success',
					text: 'order added successful!.',
					icon: 'success',
					showConfirmButton: false,
					timer: 2000,
					timerProgressBar: true,
				});
			} catch (err) {
				console.log(err.message);
				Swal.fire('Error', 'Failed to add order.', 'error');
			}
		}
	};

	const changeDriver = async () => {
		let driverid = `${driver}`;
		if (!accessToken) {
			window.location.href = `${config.BASE_URL}/login`;
			return;
		}

		const formData = new URLSearchParams();
		formData.append('driverid', driverid);
		formData.append('manifestId', manifestId);

		try {
			const response = await fetch(`${config.API_URL}/ws_update_driver`, {
				method: 'POST',
				headers: {
					authorization: `Bearer ${accessToken}`,
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body: formData.toString(),
			});

			if (!response.ok) {
				throw new Error('Failed to submit selection');
			}

			await response.json();
			Swal.fire('Success', 'Driver Update successfully', 'success');
			setShowDriverModal(false);
		} catch (error) {
			console.error('Error submitting selection:', error);
			Swal.fire('Error', 'Failed to update driver.', 'error');
		}
	};

	const handleDriverSelect = (driverId, driverName) => {
		setSelectedDriver(driverId);
		setSelectedDriverName(driverName);
	};

	const handlePrintTable = () => {
		const tableHtml = document.getElementById("newmarkdownTable").outerHTML;

		try {
			const printWindow = window.open('', '', 'width=900,height=700');
			
			if (!printWindow) {
				showPopupBlockedMessage();
				return;
			}

			setTimeout(() => {
				if (printWindow.closed || printWindow.outerHeight === 0) {
					showPopupBlockedMessage();
					return;
				}

				printWindow.document.write(`
					<html>
						<head>
							<title>Print Table</title>
							<style>
								body { font-family: Arial, sans-serif; padding: 20px; }
								table { width: 100%; border-collapse: collapse; }
								table, th, td { border: 1px solid black; }
								th, td { padding: 8px; text-align: left; }
								thead { background-color: #f1f1f1; }
							</style>
						</head>
						<body>
							<h2>Route Map</h2>
							${tableHtml}
						</body>
					</html>
				`);
				printWindow.document.close();
				printWindow.focus();
				printWindow.print();
				printWindow.close();
			}, 100);
		} catch (error) {
			showPopupBlockedMessage();
		}
	};

	const handleMultiplePrint = () => {
		console.log('Selected rows for printing:', selectedRows);

		if (selectedRows.length === 0) {
			Swal.fire({
				title: 'No Orders Selected',
				text: 'Please select at least one order to print.',
				icon: 'warning',
				showConfirmButton: true,
			});
			return;
		}

		try {
			sessionStorage.setItem('invoiceIds', JSON.stringify(selectedRows));
			generateMultipleSummaryPDF(howManyInvoiceCanPrint);
		} catch (error) {
			showPopupBlockedMessage();
		}
	};

	const handleMultiplePrintWithIds = (ids) => {
		console.log('Selected rows for printing:', ids);

		if (!ids || ids.length === 0) {
			Swal.fire({
				title: 'No Orders Selected',
				text: 'Please select at least one order to print.',
				icon: 'warning',
				showConfirmButton: true,
			});
			return;
		}

		sessionStorage.setItem('invoiceIds', JSON.stringify(ids));
		generateMultipleSummaryPDF(howManyInvoiceCanPrint);
	};

	const handleCancelManifest = async () => {
		try {
			const response = await fetch(`${config.API_URL}/manifest_cancel`, {
				method: 'POST',
				headers: {
					authorization: `Bearer ${accessToken}`,
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({ manifest_id: manifestId }),
			});
			if (!response.ok) throw new Error('Cancel failed');
			await response.json();
			Swal.fire('Cancelled', 'Route Plan has been cancelled.', 'success').then(() => {
				navigate('/delivery/route_planing');
			});
		} catch (err) {
			Swal.fire('Error', 'Failed to cancel manifest.', 'error');
		}
	};

	const handleCreateManifest = async () => {
		if (!driver || driver.trim() === '') {
			Swal.fire({
				title: 'Error',
				text: 'Please Select Driver.',
				icon: 'error',
				showConfirmButton: false,
				timer: 2000,
				timerProgressBar: true,
			});
			return;
		}

		try {
			const formOrder = new FormData();
			formOrder.append('manifest_id', manifestId);
			formOrder.append('driver_id', driver);
			const response = await fetch(`${config.API_URL}/ws-create-manifest-v3`, {
				method: 'POST',
				headers: {
					authorization: `Bearer ${accessToken}`,
				},
				body: formOrder,
			});
			if (!response.ok) throw new Error('Create failed');
			await response.json();
			Swal.fire('Success', 'Manifest created successfully!', 'success');
			navigate('/manifest_list');
		} catch (err) {
			Swal.fire('Error', 'Failed to create manifest.', 'error');
		}
	};

	const handleConfirmOrders = async () => {
		if (selectedRows.length === 0) {
			Swal.fire('Error', 'Please select at least one order.', 'error');
			return;
		}

		try {
			const response = await fetch(`${config.API_URL}/confirm-orders`, {
				method: 'POST',
				headers: {
					authorization: `Bearer ${accessToken}`,
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({ order_ids: selectedRows }),
			});

			if (!response.ok) throw new Error('API error');
			await response.json();

			Swal.fire('Success', 'Orders confirmed!', 'success');
			setIsAllSelected(false);
			setSelectedRows([]);
			fetchData();
			if (dataTableRef.current) {
				dataTableRef.current.ajax.reload();
			}
		} catch (err) {
			Swal.fire('Error', 'Failed to confirm orders.', 'error');
		}
	};

	const handleSelectAll = (e) => {
		const checked = e.target.checked;
		setIsAllSelected(checked);

		if (checked) {
			const allIds = tableData.map(row => row.id);
			setSelectedRows(allIds);
			$('.order-checkbox').prop('checked', true);
		} else {
			setSelectedRows([]);
			$('.order-checkbox').prop('checked', false);
		}
	};

	return (
		<>
			<Header />
			<div className="breadcrumbs">
				<div className="container-fluid">
					<div className="row">
						<div className="col-12 col-lg-12 col-sm-12">
							<Link to="/Dashboard"><i className="fa fa-home"></i></Link>
							<Link to="/ManifestList">Dispatch & Deliveries</Link>
							<span className="last-crumb">Manifest List</span>
						</div>
					</div>
				</div>
			</div>

			<div className="main-container position-relative">
				{Object.values(columnVisibility).every(visible => !visible) && (
					<FallbackManageColumns
						onOpenModal={() => setShowFallbackModal(true)}
					/>
				)}
				<div className="mark-delivery-filter-row row gy-1">
					<div className="col-12 d-flex justify-content-between align-items-center">
						<div className="">
							<p className="text-nowrap m-0">Driver: <b>{selectedDriverName}</b></p>
						</div>
						<div className="d-flex" role="group" style={{ gap: '10px' }}>
							<button
								type="button"
								className="btn btn-filter btn-sm text-nowrap"
								onClick={() => setShowDriverModal(true)}
							>
								Select Driver
							</button>
							<button type="button" className="btn btn-filter btn-sm text-nowrap" data-bs-toggle="modal" data-bs-target="#addNewOrderModal">Add Order</button>
							<button type="button" className="btn btn-filter btn-sm text-nowrap" onClick={handlePrintTable}>Print Manifest</button>
							<button type="button" className="btn btn-filter btn-sm text-nowrap" onClick={handleMultiplePrint}>Print Inv</button>
						</div>
					</div>
				</div>
				<div className="container-fluid">

					<div className="row">
						<div className="col-12">
							<div className="dashboard newmarkdown">
								<div className="verical-scrl-wrapper newmarkdown mt-4" id="style-3">
									<table
										className="table toggleColumn table-bordered dataTable resizable"
										ref={tableRef}
										id="newmarkdownTable"
									>
										<thead>
											<tr>
												<th style={{ width: colWidths[0], position: "relative" }}>
													<div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
														<label className="checkbox">
															<input
																type="checkbox"
																onChange={handleSelectAll}
																checked={isAllSelected}
															/>
															<span className="default"></span>
														</label>
														{colWidths.length > 0 && (
															<>
																<div
																	className="th-resizer"
																	onMouseDown={(e) => startResizing(0, e)}
																/>
																<ManageColumns
																	tableName={tableName}
																	header="Checkbox"
																	index={0}
																	columns={tableColumns}
																	columnVisibility={columnVisibility}
																	onColumnVisibilityChange={handleColumnVisibilityChange}
																	excludeColumns={["Checkbox", "Seq. No", "Action"]}
																/>
															</>
														)}
													</div>
												</th>

												{[
													"Seq. No",
													"Distance",
													"Inv Date",
													"Inv Number",
													"Customer Name(A/c No)",
													"Post Code",
													"Inv Amt",
													"Amt Dues",
													"Action",
												].map((header, idx) => (
													<th
														key={header}
														style={{
															width: colWidths[idx + 1],
															minWidth: 50,
															position: "relative",
															display: columnVisibility[idx + 1] !== false ? 'table-cell' : 'none'
														}}
													>
														<div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
															{header}
															<>
																<div
																	className="th-resizer"
																	onMouseDown={(e) => startResizing(idx + 1, e)}
																/>
																<ManageColumns
																	tableName={tableName}
																	header={header}
																	index={idx + 1}
																	columns={tableColumns}
																	columnVisibility={columnVisibility}
																	onColumnVisibilityChange={handleColumnVisibilityChange}
																	excludeColumns={["Checkbox", "Seq. No", "Action"]}
																/>
															</>
														</div>
													</th>
												))}
											</tr>
										</thead>
										<tbody></tbody>
										<tfoot>
											{!isManifest && (
												<tr>
													<td colSpan="10">
														<div
															className="table-footer"
															style={{
																display: "flex",
																justifyContent: "flex-end",
																gap: "10px",
																paddingTop: "10px",
															}}
														>
															<button
																type="button"
																className="common-closebtn"
																onClick={handleCancelManifest}
															>
																Cancel
															</button>

															<button
																type="button"
																className="float-right-btn common-popup-btn"
																onClick={handleCreateManifest}
															>
																Create Manifest
															</button>
														</div>
													</td>
												</tr>
											)}
										</tfoot>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<Footer />

			<StandaloneManageColumnsModal
				show={showFallbackModal}
				onHide={() => setShowFallbackModal(false)}
				tableName={tableName}
				columns={tableColumns}
				columnVisibility={columnVisibility}
				onColumnVisibilityChange={handleColumnVisibilityChange}
				excludeColumns={["Checkbox", "Action", "Seq. No"]}
			/>

			{showDriverModal && (
				<div className="modal fade show d-block" tabIndex="-1">
					<div className="modal-dialog modal-dialog-centered">
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title">Select Driver</h5>
								<button
									type="button"
									className="btn-close"
									onClick={() => setShowDriverModal(false)}
								></button>
							</div>
							<div className="modal-body">
								<div className="form-group">
									<label className="form-label">Choose Driver</label>
									<select
										className="form-select"
										value={driver}
										onChange={(e) => {
											const selectedOption = options.find(opt => opt.value === e.target.value);
											setSelectedDriver(e.target.value);
											setSelectedDriverName(selectedOption ? selectedOption.key : '');
										}}
									>
										<option value="">Select a driver</option>
										{options.map(option => (
											<option key={option.value} value={option.value}>
												{option.key}
											</option>
										))}
									</select>
								</div>
							</div>
							<div className="modal-footer">
								<button
									type="button"
									className="btn btn-secondary"
									onClick={() => setShowDriverModal(false)}
								>
									Cancel
								</button>
								<button
									type="button"
									className="btn btn-primary"
									onClick={changeDriver}
								>
									Submit
								</button>
							</div>
						</div>
					</div>
				</div>
			)}

			<div className="modal fade" id="addNewOrderModal" tabIndex="-1">
				<div className="modal-dialog">
					<div className="modal-content">
						<div className="modal-header">
							<h5 className="modal-title">Add New Order</h5>
							<button type="button" className="btn-close" data-bs-dismiss="modal"></button>
						</div>
						<div className="modal-body">
							<select
								value={manifestOrder}
								onChange={(e) => setmanifestOrder(e.target.value)}
								className="form-select"
							>
								<option value="">Select Order</option>
								{orderOptions.map(option => (
									<option key={option.value} value={option.value}>
										{option.key}
									</option>
								))}
							</select>
						</div>
						<div className="modal-footer">
							<button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
							<button type="button" className="btn btn-primary" onClick={handleClick} data-bs-dismiss="modal">Add Order</button>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default NewMarkDelivery;